$(document).on('change', '[name="id"]', function(){

  var selected_variant = $('[name="id"]'),
      selected_variant_id = selected_variant.val(),
      selected_variant_price = selected_variant.find('option:selected').data('price');
  
  
     console.log(selected_variant_price)
  	//selected_variant.parent().removeClass('btn-outline-secondary').addClass('btn-secondary').siblings().removeClass('btn-secondary').addClass('btn-outline-secondary')
  	
  
  	if(window.affirm){
      	$('.affirm-as-low-as').data('amount', selected_variant_price)
    	affirm.ui.refresh();
    }

}).on('submit', '.gift-card-product form', function(){

	var $form = $(this);
  
 
  
  	$form.loading()
      jQuery.post('/cart/add.js', $form.serialize(), function(cart){
       
        $form.stopLoading();   
        
        openCart()
        
     }, "json");
  
  return false
  
}).on('click', '.vt-card-preview-open', function(){

	$('.vt-gift-cards-gallary').addClass('open')
  
}).on('click', '.vt-gift-cards-gallary-close', function(){

	$('.vt-gift-cards-gallary').removeClass('open')
  
}).on('click', '.vt-gift-card-image', function(){

	var selectedImage = $(this).data('image');
    $('.vt-card-preview img').attr('src', selectedImage);
  	$('.vt-gift-cards-gallary').removeClass('open');
  	$('.vt-product-image-container').attr('href', selectedImage).css('background-image', 'url('+ selectedImage +')')
  
})